










































import { Component, Vue } from "vue-property-decorator";
import { Field, Button } from "vant";
import store from "store";

@Component({
  name: "PhoneVerify",
  components: {
    [Field.name]: Field,
    [Button.name]: Button
  }
})
export default class PhoneVerify extends Vue {
  form = {
    zone_code: "",
    phone: "",
    code: ""
  };

  isSendVerCode = false;
  verCodeTime = 120;
  verCodeTimer: any = null;
  get computedPhone() {
    return `+${this.form.zone_code} ${this.form.phone}`;
  }

  get sendVerCodeText() {
    return this.isSendVerCode ? `(${this.verCodeTime}S)` : "获取";
  }

  get isSubmitDisabled() {
    return !this.form.code;
  }
  created() {
    const { zone_code, phone } = store.get("userInfo");
    this.form.zone_code = zone_code;
    this.form.phone = phone;
  }

  handleSendVerCode() {
    const { phone, zone_code } = this.form;
    const params = {
      phone,
      zone_code,
      msg_show: 1,
      type: 4 //1登录，2注册，3找回密码
    };
    (this as any).$apis
      .sendVerCode(params)
      .then(res => {
        
        this.isSendVerCode = true;
        this.form.code = res.code;
        this.$toast(this.$t("common.message_send_success_text"));
        this.setIntervalSendVerCode();
      })
      .catch(e => {
        
      });
  }

  setIntervalSendVerCode() {
    this.verCodeTimer = setInterval(() => {
      this.verCodeTime--;
      if (this.verCodeTime == 0) {
        clearInterval(this.verCodeTimer);
        this.verCodeTime = 120;
        this.isSendVerCode = false;
      }
    }, 1000);
  }

  handleVerifyVerCode() {
    const { path, ...query } = this.$route.query;
    const _path: any = path;
    const _query: any = query;
    const params = {
      code: this.form.code,
      phone: this.form.phone,
      type: 4
    };
    (this as any).$apis
      .verifyVerCode(params)
      .then(() => {
        this.$router.replace({
          path: _path,
          query: _query
        });
      })
      .catch(e => {
        
      });
  }
}
